import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output, ViewContainerRef } from '@angular/core';
import { from } from 'rxjs';

import { MapApi } from '../../../api/map-api';
import { IAuthenticationService } from '../../../services/interfaces/IAuthenticationService';
import { MapService } from '../../../services/map.service';
import { BaseComponent } from '../../base.component';

/* tslint:disable:template-cyclomatic-complexity */
@Component({
    selector: 'mc-map-catalog-item-ng',
    styleUrls: ['./map-catalog-item.component.scss'],
    templateUrl: './map-catalog-item.component.html'
})
export class MapCatalogItemComponent extends BaseComponent {
    get includeGoogleAnalytics() { return false; }

    @Input() map: any;
    @Input() mapItemType: string;
    @Input() mergeMaps: boolean;
    @Input() multiSelectEnabled: boolean;
    @Input() owner: boolean = false;
    @Output() readonly closeWindowEvent = new EventEmitter<boolean>();
    @Output() readonly changeFolderEvent = new EventEmitter<number>();
    @Output() readonly deleteMapEvent = new EventEmitter<any>();
    @Output() readonly mapOpened = new EventEmitter<any>();
    checkedMap: any;
    expanded: boolean = false;
    error: any;
    showMap;
    showMapDetailIcon: string = 'icon-ui-arrow-down-circled';
    canViewUsers = false;
    private _userId = null;
    @Input()
    get userId() { return this._userId; }
    set userId(value: number) {
        this._userId = value;
    }

    get includeEsriCss() { return false; }
    get includeOverrideCss() { return false; }

    get publicUrl() {
        let retVal: string = null;
        if (this.map && this.map.isPublic) {
            const newUrl = new URL(window.location.href);
            newUrl.search = `mapId=${this.map.id}`;
            retVal = newUrl.href;
        }
        return retVal;
    }

    @Output() readonly openMergeMap: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        @Inject('authenticationService') authService: IAuthenticationService,
        _vcr: ViewContainerRef,
        private readonly mapApi: MapApi,
        private readonly mapService: MapService,
        private readonly ref: ChangeDetectorRef
        ) {
        super(_vcr, true);
        authService.permissions.subscribe(permissions => {
            this.canViewUsers = permissions && permissions.includes('View Users');
        });
    }

    toggleMapItem() {
        this.expanded = !this.expanded;
        this.showMapDetailIcon = this.expanded ? 'icon-ui-arrow-up-circled' : 'icon-ui-arrow-down-circled';
    }

    toggleMultiSelectCheckbox() {
        this.map.selected = !(this.map.selected === true);
    }

    async mergeMap() {
        this.openMergeMap.emit(this.map);
        await this.closeWindow();
    }
    async getMapDetails(map) {
      // this.checkedMap=[];
        const mapIds = [map.id];
        const mapProps = this.mapApi.mapProperties + ', userMaps { userId, accessLevel, sharedWith{ userId }}';
        if (mapIds.length) {
            //get the maps by the provided ids back from UserMaps to get their data
            const maps = await this.mapService.getMaps(mapIds, mapProps);
            this.checkedMap = from(maps.map(Map => {
                const sharedWith = this.cleanMapGetSharedWith(Map);
                return { Map, sharedWith};
            }));
            this.checkedMap.subscribe(res => {
                this.showMap = res;
                this.ref.detectChanges();
            });
        }
    }
    cleanMapGetSharedWith(map): any[] {
        //establish a workable, not null user maps arr for the map
        const userMapsArr = map.userMaps && Array.isArray(map.userMaps) && map.userMaps.length ? map.userMaps : [];
        //determine user who owns this map
        const ownerRec = userMapsArr.find(item => item.accessLevel === 'OWNER');
        if (ownerRec && map.users && Array.isArray(map.users)) {
            //try to find the owner in Users to get their info
            const ownerUser = map.users.find(item => item.id === ownerRec.userId);
            if (ownerUser) {
                map.owner = ownerUser;
            }
        }

        //find the current user in the map record
        const currentUserMapRec = userMapsArr.find(item => item.userId === this.userId);
        let sharedWith = [];
        //if the current user is properly listed in the userMaps array, it will have an array of sharedWith to indicate who this user has shared the map with
        //this array should be the one used to determine if the unshare button should show or not.
        if (currentUserMapRec && currentUserMapRec.sharedWith) {
            sharedWith = currentUserMapRec.sharedWith;
        }
        return sharedWith;
    }
    async openMap() {
        this.closeWindow();
        await this.mapService.openMap(this.map);
        this.mapOpened.emit(this.map);
    }

    async shareMap() {
        const win: any = window.document.getElementById('shareMapWindow');

        if (win) {
            win.open();
            const shareMap = win.firstElementChild; // as ShareMapComponent; // todo TFS#13854
            shareMap.map = this.map;
        }

        await this.closeWindow();
    }

    async unshareMap() {
        const win: any = window.document.getElementById('unshareMapWindow');
        if (win) {
            win.open();
            const unshareMap = win.firstElementChild; // as UnShareMapComponent; // todo TFS#13854
            unshareMap.map = this.map;
        }
        await this.closeWindow();
    }

    async deleteMap(map) {
        this.deleteMapEvent.emit(map);
    }

    changeFolder(map) {
        this.changeFolderEvent.emit(map.id);
    }

    closeWindow() {
        this.multiSelectEnabled = false;
        if (this.map.length !== undefined) {
            this.map.forEach(x => x.selected = false);
        }
        this.closeWindowEvent.emit(true);
    }
}
